import { put } from "redux-saga/effects";
import { loginFailed, updateSession } from '../actions/Session'


export function* login({ firebaseApp }, { payload: { user, password } }) {
    yield firebaseApp.auth().setPersistence("session")
    var status = yield firebaseApp.auth().signInWithEmailAndPassword(user, password).catch((error) => {
        return error.code
    })
    if (typeof status === "string") {
        switch (status) {
            case "auth/wrong-password":
                yield put(loginFailed("Contraseña Incorrecta" )); break;
            case "auth/invalid-email":
                yield put(loginFailed("Correo Inválido" )); break;
            case "auth/user-not-found":
                yield put(loginFailed("Correo Inválido" )); break;
            case "auth/too-many-requests":
                yield put(loginFailed("Se han detectado múltiples intentos de inicio de sesión" )); break;
            default:
                yield put(loginFailed("Error al iniciar sesión" )); break;
        }
    }
}

export function* logout({ firebaseApp }) {
    firebaseApp.auth().signOut()
    yield put(updateSession(null))
}
